// extracted by mini-css-extract-plugin
export default {"section-container":"ProjectList_section-container__jgGjj","section-heading-primary":"ProjectList_section-heading-primary__lFK9Y"};